import { ComponentType, MouseEventHandler, useRef } from 'react';
import overlay from '@activebrands/core-web/libs/overlay';
import generateRandomString from '@grebban/utils/string/generateRandomString';

type NotificationMouseHandler = MouseEventHandler<HTMLElement>;

const useNotifications = () => {
    const timeouts = useRef<Record<string, ReturnType<typeof setTimeout>>>({});

    const remove = (id: string) => {
        overlay.close(id);
    };

    const push = (
        component: ComponentType<{
            id: string;
            onMouseEnter?: NotificationMouseHandler;
            onMouseLeave?: NotificationMouseHandler;
        }>,
        componentProps: {
            id?: string;
            [key: string]: unknown;
            onMouseEnter?: NotificationMouseHandler;
            onMouseLeave?: NotificationMouseHandler;
        } = {},
        timeout = 7000
    ) => {
        const id = componentProps.id || `notification-${generateRandomString(7)}`;

        const props = {
            id,
            ...componentProps,
        };

        overlay.open(id, { component, props });

        if (timeout) {
            props.onMouseEnter = () => {
                clearTimeout(timeouts.current[id]);
            };

            props.onMouseLeave = () => {
                timeouts.current[id] = setTimeout(() => {
                    remove(id);
                }, timeout);
            };

            timeouts.current[id] = setTimeout(() => {
                remove(id);
            }, timeout);
        }

        return id;
    };

    return {
        push,
        remove,
    };
};

export default useNotifications;
